package com.exura.features.plandefinition.domain.model.metadata

import com.exura.features.firebase.domain.model.versioning.VersionMetadata
import com.exura.features.userprofile.domain.model.Stamp
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("plan_definition_meta")
data class PlanDefinitionMetadata(
    val fields: PlanDefinitionFields,
    val statistics: PlanDefinitionStatistics,
) : VersionMetadata
